import {Avatar} from "primereact/avatar";
import {ColorizedAvatars} from "../../../ui/elements/ColorizedAvatars";
import {Button} from "primereact/button";
import {base, usersURL} from "../../../../api";
import {GrStatusGoodSmall} from "react-icons/gr";
import {CiMobile1} from "react-icons/ci";
import {CiUser} from "react-icons/ci";
import {Menu} from "primereact/menu";
import {useRef, useState} from "react";
import {ConfirmDialog} from "primereact/confirmdialog";
import axios from "axios";

export const usersListAvatarBody = rowData => (
	<div className={`d-flex align-items-center p-0 opacity-${rowData?.is_active ? 100 : 60}`}>
		<div className="me-3" style={{width: "45px", height: "45px"}}>
			{rowData?.profile?.avatar ? (
				<Avatar
					image={rowData?.profile?.avatar}
					shape="circle"
					style={{width: "45px", height: "45px"}}
				/>
			) : (
				<Avatar
					label={rowData?.username?.substring(0, 1)}
					shape="circle"
					className="text-uppercase text-white"
					style={
						rowData?.is_active
							? {
									backgroundColor: ColorizedAvatars(rowData?.username?.substring(0, 2)),
									width: "45px",
									height: "45px",
							  }
							: {width: "45px", height: "45px"}
					}
				/>
			)}
		</div>
		<div className="d-grid">
			<div className="">
				<CiUser />
				<span className="text-dark fw-bold fs-6 ms-2">
					{rowData.username}
					{rowData?.is_active ? (
						<GrStatusGoodSmall className="text-success ms-2" />
					) : (
						<GrStatusGoodSmall className="text-danger ms-2" />
					)}
				</span>
			</div>
			<div className="my-1">
				<CiMobile1 />
				<span className="small ms-2">
					{rowData?.profile?.mobile ? (
						rowData?.profile?.mobile
					) : (
						<span className="text-danger small fs-italic">user must have mobile number</span>
					)}
				</span>
			</div>
		</div>
	</div>
);

export const usersListActiveUsers = rowData => (
	<div className="d-flex align-items-center p-0">
		{rowData?.is_active ? (
			<Button icon="pi pi-check" rounded severity="success" disabled />
		) : (
			<Button icon="pi pi-times" rounded severity="danger" disabled />
		)}
	</div>
);

export const ActionMenuCell = props => {
	const menuRef = useRef(null);

	console.log(props);

	const items = [
		{
			label: "Actions",
			items: [
				{
					label: "View More",
					icon: "pi pi-info-circle",
					command: () => {
						if (!props?.rowData?.id) return;
						localStorage.setItem("item", props?.rowData.id);
						props?.setvisible(true);
						props?.setEditCurrentState(props?.rowData.id);
					},
				},
				{
					label: "More Information",
					icon: "pi pi-external-link",
					command: () => {
						if (!props?.rowData.id) return;
						localStorage.setItem("item", props?.rowData.id);
						window.location.href = `/co_workers/${props?.rowData.id}`;
					},
				},
				{
					label: "Edit User",
					icon: "pi pi-user-edit",
					command: () => {
						if (!props?.rowData?.id) return;
						localStorage.setItem("item", props?.rowData.id);
						props?.setvisible(true);
						props?.setEditCurrentState(props?.rowData.id);
					},
				},
				{
					label: "Reset Password",
					icon: "pi pi-refresh",
					command: () => {
						if (!props?.rowData?.id) return;
						localStorage.setItem("item", props?.rowData.id);

						props?.confirmReset(props.rowData.id);
					},
				},
				{
					label: "Delete User",
					icon: "pi pi-times",
					command: () => {
						if (!props?.rowData?.id) return;
						localStorage.setItem("item", props?.rowData.id);

						props?.confirmdelete(props.rowData.id);
					},
				},
			],
		},
	];

	return (
		<div className="col-2 text-end">
			<Menu model={items} popup ref={menuRef} />
			<Button
				icon="pi pi-ellipsis-v"
				rounded
				severity="secondary"
				className="opacity-75"
				onClick={event => menuRef.current.toggle(event)}
				aria-haspopup
			/>
		</div>
	);
};
